
















































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'

import UserInterface2FolderDataTable from '../../../../../html-components-type-1-basic/basic-type-4-user-interface/user-interface-2-folder-data-table.vue'
import UserInterface5AreYouSure from '../../../../../html-components-type-1-basic/basic-type-4-user-interface/user-interface-5-are-you-sure.vue'
import Input3InputWithUpdateButton from '../../../../../html-components-type-1-basic/basic-type-3-input/input-3-input-with-update-button.vue'


import {
  DataTableFile,
  GraphViewDataTableItem,
  itemTypeFolder,
  itemTypeGraph,
  itemTypeAccount,
  ItemType
} from '../../../../../html-components-type-1-basic/basic-type-4-user-interface/service-for-data-structures/data-structures-1-file-system-data-structure'

import { Group, GROUP_ITEM_TYPE_ACCOUNT } from '../../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-2-digital-currency-account/digital-currency-account-type-2-data-structures/data-structures-type-5-account-groups/account-groups-1'
import { DigitalCurrencyAccount } from '../../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-2-digital-currency-account/digital-currency-account-type-2-data-structures/data-structures-type-1-service-data-structure/service-data-structure-1'
import { MAXIMUM_NUMBER_OF_GROUPS } from '../../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-2-digital-currency-account/digital-currency-account-type-1-algorithms/algorithms-type-20-create-digital-currency-account-group/create-digital-currency-account-group-1'

const namespace = 'digitalCurrency'

@Component({
  components: {
    UserInterface2FolderDataTable,
    UserInterface5AreYouSure,
    Input3InputWithUpdateButton
  }
})
class AccountResourceItem4YourGroups extends Vue {

  @Prop({ default: '' }) accountId?: string
  @Prop({ default: false }) isPublicAccountViewing?: boolean

  // @Getter('getActiveDigitalCurrencyAccount', { namespace }) getActiveDigitalCurrencyAccount?: any
  @Getter('getDigitalCurrencyAccountGroupList', { namespace }) getDigitalCurrencyAccountGroupList?: any
  @Getter('getDigitalCurrencyAccountGroup', { namespace }) getDigitalCurrencyAccountGroup?: any

  @Action('getDigitalCurrencyAccountById', { namespace }) getDigitalCurrencyAccountById?: any
  @Action('removeItemFromGroup', { namespace }) removeItemFromGroup?: any
  @Action('updateDigitalCurrencyAccountGroup', { namespace }) updateDigitalCurrencyAccountGroup?: any
  @Action('deleteDigitalCurrencyAccountGroup', { namespace }) deleteDigitalCurrencyAccountGroup?: any
  @Action('createDigitalCurrencyAccountGroup', { namespace }) createDigitalCurrencyAccountGroup?: any

  selectedGroupId: string = ''
  selectedGroupItemList: GraphViewDataTableItem[] = []

  groupList: Group[] = []

  initialFile?: DataTableFile

  showAreYouSureDialog: boolean = false
  areYouSureDialogIconId: string = ''
  areYouSureDialogTitle: string = ''
  areYouSureDialogMessage: string = ''
  areYouSureDialogHeaderCssClass: string = ''
  areYouSureDialogYesOptionEvaluationFunction: any = () => false

  showGroupSettingsDialog: boolean = false
  showCreateGroupDialog: boolean = false

  newGroupName: string = ''
  isValidGroupName: boolean = false
  errorMessage: string = ''

  async getDataTableInitialFile () {

    const self = this

    const groupList = this.getDigitalCurrencyAccountGroupList(this.accountId).reverse()
    this.groupList = groupList

    let initialFile = new DataTableFile()

    const showAddNewGroupButton = !this.isPublicAccountViewing && (groupList.length < MAXIMUM_NUMBER_OF_GROUPS)
    initialFile.actionButtonList = showAddNewGroupButton ? [{
      iconImageId: 'add',
      text: 'New Group',
      cssClass: 'primary',
      evaluateFunction: () => {
        this.showCreateGroupDialog = true
      }
    }] : []

    for (let i = 0; i < groupList.length; i++) {
      const group: Group = groupList[i]

      const groupItemTable: { [groupItemId: string]: GraphViewDataTableItem } = {}

      for (let itemId in group.groupItemIdVariableTable) {
        if (!group.groupItemIdVariableTable.hasOwnProperty(itemId)) {
          continue
        }
        const groupItem = group.groupItemIdVariableTable[itemId]
        let itemName = ''
        let itemIconImageUrl = ''
        let itemType: ItemType = itemTypeFolder
        let openFolderOrFileItem = false
        let closingActionButtonIconId = ''
        let closingActionButtonText = ''

        if (groupItem.itemType === GROUP_ITEM_TYPE_ACCOUNT) {
          const digitalCurrencyAccount: DigitalCurrencyAccount | null = await this.getDigitalCurrencyAccountById(groupItem.itemId)
          if (digitalCurrencyAccount) {
            itemType = itemTypeAccount
            itemName = digitalCurrencyAccount.accountName
            itemIconImageUrl = digitalCurrencyAccount.accountProfilePictureUrl
            openFolderOrFileItem = true
            closingActionButtonIconId = 'visibility'
            closingActionButtonText = 'View Account'
          }
        }

        groupItemTable[groupItem.itemId] = {
          itemId: groupItem.itemId,
          itemType,
          itemName,
          itemIconImageUrl,
          openFolderOrFileItem,
          closingActionButtonIconId,
          closingActionButtonText
        }
      }

      const dataTableFile: DataTableFile = {
        itemType: itemTypeGraph,
        itemId: group.groupId,
        itemName: group.groupName,
        itemIconImageUrl: 'folder',
        itemData: {
          graphType: 'data-table',
          graphData: {
            hasOpeningIcon: true,
            hasClosingActionButton: true,
            dataTableSearchTextFieldLabel: 'Search Group',
            dataTableShowSettingsButton: !this.isPublicAccountViewing,
            dataTableShowSelectCheckbox: !this.isPublicAccountViewing,
            selectedItemList: this.selectedGroupItemList,
            dataTableSettingsButtonFunction: () => {
              this.showGroupSettingsDialog = true
            },
            dataTableSelectItemEventListener: (data: any) => {
              // console.log('selected: ', data)
              Vue.set(self, 'selectedGroupItemList', data)
            },
            dataTableActionButtonList: self.selectedGroupItemList.length > 0 ? this.getDataTableActionButtonList.buttonList : [],
            dataTableHeaderList: [{
              text: 'Item Id',
              value: 'itemId'
            }, {
              text: 'Item Name',
              value: 'itemName'
            }, {
              text: 'Item Type',
              value: 'itemType'
            }],
            dataTableDataList: Object.keys(groupItemTable).map((groupItemId: string) => groupItemTable[groupItemId])
          }
        },
        fileVariableTable: groupItemTable
      }

      initialFile.fileVariableTable![group.groupId] = dataTableFile
    }

    return initialFile
  }

  get getDataTableActionButtonList () {

    const dataTableActionButtonList = [{
      iconImageId: 'cancel',
      text: 'Remove',
      cssClass: 'error',
      evaluateFunction: () => {
        this.showAreYouSureDialog = true
        this.areYouSureDialogIconId = 'cancel'
        this.areYouSureDialogTitle = 'Remove Group Items'
        this.areYouSureDialogMessage = `Are you sure you wish to delete ${this.selectedGroupItemList.length} group ${this.selectedGroupItemList.length > 1 ? 'items' : 'item'}?`
        this.areYouSureDialogHeaderCssClass = 'error'

        this.areYouSureDialogYesOptionEvaluationFunction = async () => {
          // Delete items
          for (let i = 0; i < this.selectedGroupItemList.length; i++) {
            await this.removeItemFromGroup({
              groupId: this.selectedGroupId,
              itemId: this.selectedGroupItemList[i].itemId
            })
          }

          // Reset Are You Sure Dialog
          this.resetAreYouSureDialog()

          this.selectedGroupItemList = []
        }
      }
    }]

    let isSelectedItemListOnlyAccount = this.selectedGroupItemList.length > 0 ? true : false
    for (let i = 0; i < this.selectedGroupItemList.length; i++) {
      const isItemTypeAccount = this.selectedGroupItemList[i].itemType === GROUP_ITEM_TYPE_ACCOUNT
      isSelectedItemListOnlyAccount = isSelectedItemListOnlyAccount && isItemTypeAccount
    }

    if (isSelectedItemListOnlyAccount) {
      dataTableActionButtonList.unshift({
        iconImageId: 'send',
        text: 'Send Payment',
        cssClass: 'success',
        evaluateFunction: async () => {
          //
        }
      })
    }

    return {
      buttonList: dataTableActionButtonList,
      blankValue: ''
    }
  }

  deleteGroup () {
    this.showAreYouSureDialog = true
    this.areYouSureDialogIconId = 'delete'
    this.areYouSureDialogTitle = 'Delete Group'
    this.areYouSureDialogMessage = `Are You Sure You Wish To Delete This Group?`
    this.areYouSureDialogHeaderCssClass = 'error'
    this.areYouSureDialogYesOptionEvaluationFunction = async () => {
      await this.deleteDigitalCurrencyAccountGroup({
        digitalCurrencyAccountId: this.accountId,
        groupId: this.selectedGroupId
      })
      this.resetAreYouSureDialog()
      this.showGroupSettingsDialog = false
    }
  }

  async createGroup () {
    if (!this.isValidGroupName) {
      return
    }

    await this.createDigitalCurrencyAccountGroup(this.newGroupName).catch((errorMessage: any) => {
      this.errorMessage = errorMessage
    })

    this.showCreateGroupDialog = false
    this.newGroupName = ''
  }

  onSelectedFolderDataTableItem (selectedItem: any) {

    this.selectedGroupItemList = []

    if (!selectedItem) {
      return
    }

    const isSelectedItemGroup = this.groupList.filter((group) => {
      return group.groupId === selectedItem.itemId
    })[0] ? true : false

    if (isSelectedItemGroup) {
      this.selectedGroupId = selectedItem.itemId
    }
  }

  resetAreYouSureDialog () {
    this.showAreYouSureDialog = false
    this.areYouSureDialogIconId = ''
    this.areYouSureDialogTitle = ''
    this.areYouSureDialogMessage = ''
    this.areYouSureDialogHeaderCssClass = ''
    this.areYouSureDialogYesOptionEvaluationFunction = () => false
  }

  requireInput (inputValue: any) {
    return !!inputValue || 'Must have input value'
  }

  requireLessThanN1Characters (inputValue: any) {
    return inputValue.length <= 30 || 'Must have less than 30 characters'
  }

  requireAlphanumericCharacters (inputValue: any) {
    const regularExpressionPattern = /^([a-zA-Z0-9 _-]+)$/

    return regularExpressionPattern.test(inputValue) || 'Must contain alphanumeric characters only'
  }
}

export default AccountResourceItem4YourGroups


